<template>
  <el-dialog
    :visible.sync="visible"
    :width="width"
    :close-on-click-modal="false"
    :show-close="showClose"
    @closed="finish"
    class="prompt-modal"
    append-to-body
  >
    <div slot="title">
      <slot name="title" />
    </div>
    <slot name="content" />
    <div slot="footer" class="dialog-footer">
      <el-button v-if="!footer" class="btn-80-30-primary" type="primary" @click="finish">
        确定
      </el-button>
      <slot v-else name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'promptModal',
  data() {
    return {
      visible: false,
    };
  },
  props: {
    width: {
      type: String,
      default: '420px',
    },
    footer: {
      // 是否自定义
      type: Boolean,
      default: false,
    },
    promptModalVisible: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    promptModalVisible(newVal, oldVal) {
      console.log('newVal', newVal);
      this.visible = newVal;
    },

    // promptModalVisible:{
    //     handler(newVal){
    //         console.log('newVal===>',newVal);
    //         this.visible = newVal
    //         if(newVal){this.visible =true}else{
    //             this.visible =false
    //         }
    //     },
    //     immediate: true,
    //     deep:true
    // }
  },
  methods: {
    finish() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/user-common.scss';
.prompt-modal {
  ::v-deep {
    .el-dialog__header {
      padding: 0;
      background: #f5f5f5;
      height: 40px;
      line-height: 40px;
      text-align: center;
      .el-dialog__title {
        line-height: 1;
        font-size: 14px;
      }

      .el-dialog__headerbtn {
        height: 40px;
        right: 10px;
        top: 0px;
      }
    }
    .el-dialog__footer {
      width: 100%;
      height: 50px;
      text-align: center;
      padding: 0;
    }
  }
}
</style>
